/** A failed read is unknown, never evidence that all sync sources are healthy. */
export async function syncAlertState<T extends { health: string; source: string }>(
  load: () => Promise<T[]>,
): Promise<{ kind: 'healthy' } | { kind: 'unavailable' } | { kind: 'problems'; problems: T[] }> {
  try {
    const problems = (await load()).filter((source) => source.health === 'failed' || source.health === 'stale');
    return problems.length ? { kind: 'problems', problems } : { kind: 'healthy' };
  } catch {
    return { kind: 'unavailable' };
  }
}
